import { TextField } from "@shopify/polaris"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export default function VendorField(props) {
	const { t } = useTranslation()
	const [vendor, setVendor] = useState("")

	const onChange = (change) => {
		setVendor(change)
		props.onVendorChange(change)
	}

	useEffect(() => {
		setVendor(props.vendor)
	}, [props.vendor])

	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "1rem",
				}}
			>
				<TextField
					label={t("other.product_vendor")}
					value={vendor}
					onChange={onChange}
				/>
			</div>
		</>
	)
}
